var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Preliminary Text")]),_c('p',[_c('vue-ckeditor',{attrs:{"config":_vm.config},model:{value:(_vm.localText),callback:function ($$v) {_vm.localText=$$v},expression:"localText"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }